import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { AgenteControlEditComponent } from './agentescontrol/agentecontrol-edit.component';
import { AgenteControlListComponent } from './agentescontrol/agentecontrol-list.component';
import { AgenteControlCaEditComponent } from './agentescontrol/agentecontrolca-edit.component';
import { CampaniaEntidadEditComponent } from './entidadesauditoras/campaniaentidad-edit.component';
import { EntidadAuditoraEditComponent } from './entidadesauditoras/entidadauditora-edit.component';
import { EntidadAuditoraListComponent } from './entidadesauditoras/entidadauditora-list.component';
import { TecnicoEntidadEditComponent } from './entidadesauditoras/tecnicoentidad-edit.component';
import { ExportadorEditComponent } from './exportadores/exportador-edit.component';
import { ExportadorListComponent } from './exportadores/exportador-list.component';
import { InstalacionEditComponent } from './instalaciones/instalacion-edit.component';
import { InstalacionListComponent } from './instalaciones/instalacion-list.component';
import { LaboratorioEditComponent } from './laboratorios/laboratorio-edit.component';
import { LaboratorioListComponent } from './laboratorios/laboratorio-list.component';
import { CodigoconfeccionWrapperComponent } from './codigosconfeccion/codigoconfeccion-wrapper/codigoconfeccion-wrapper.component';
import { CodigoConfeccionEditComponent } from './codigosconfeccion/codigoconfeccion-edit/codigoconfeccion-edit.component';
import { TecnicoLaboratorioEditComponent } from './laboratorios/tecnicolaboratorio-edit.component';
import { DialogMode } from '../../_campanias/types/enum';
import { RegistroSanitarioWrapperComponent } from './registrosanitario/registrosanitario-wrapper/registrosanitario-wrapper.component';
import { RegistroSanitarioWrapperEditComponent } from './registrosanitario/registrosanitario-wrapper-edit/registrosanitario-wrapper-edit.component';

const registrosRoutes: Routes = [
    // EXPORTADORES
    {
        path: 'mantenimiento/registros/exportadores',
        data: {
            breadcrumb: 'Exportadores',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: ExportadorListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: ExportadorEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Exportador',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: ExportadorEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Exportador',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // ENTIDAD AUDITORAS
    {
        path: 'mantenimiento/registros/entidadesauditoras',
        data: {
            breadcrumb: 'Buscador de Entidades Auditoras',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: EntidadAuditoraListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',

                data: {
                    breadcrumb: 'Editar Entidad Auditora',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },

                children: [
                    {
                        path: '',
                        component: EntidadAuditoraEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'campanias/edit/:idCampania',
                        component: CampaniaEntidadEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Editar Campaña Autorizada',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'campanias/create',
                        component: CampaniaEntidadEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nueva Campaña',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },

                    {
                        path: 'tecnicos/edit/:idTecnico',
                        component: TecnicoEntidadEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],

                        data: {
                            breadcrumb: 'Editar Técnico Autorizado',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'tecnicos/create',
                        component: TecnicoEntidadEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nuevo Técnico',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },
            {
                path: 'create',
                component: EntidadAuditoraEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Entidad Auditora',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // CÓDIGO CONFECCIÓN - Almacenes
    {
        path: 'mantenimiento/registros/codigosconfeccion',
        data: {
            breadcrumb: 'Almacenes',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: CodigoconfeccionWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    mode: DialogMode.Basic,
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'view/:id',
                component: CodigoConfeccionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    readonly: true,
                    breadcrumb: 'Consultar Almacén',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: CodigoConfeccionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Almacén',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: CodigoConfeccionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Almacén',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // CÓDIGO CONFECCIÓN IMPORTACIÓN - Registros Sanitarios
    {
        path: 'mantenimiento/registros/registrossanitarios',
        data: {
            breadcrumb: 'Registros Sanitarios',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: RegistroSanitarioWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    mode: DialogMode.Basic,
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: RegistroSanitarioWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Registro Sanitario',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: RegistroSanitarioWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Registro Sanitario',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // INSTALACIÓN
    {
        path: 'mantenimiento/registros/instalaciones',
        data: {
            breadcrumb: 'Buscador de Instalaciones',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: InstalacionListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: InstalacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Instalación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'create',
                component: InstalacionEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Instalación',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    // LABORATORIOS
    {
        path: 'mantenimiento/registros/laboratorios',
        data: {
            breadcrumb: 'Buscador de Laboratorios',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: LaboratorioListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',

                data: {
                    breadcrumb: 'Editar Laboratorio',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },

                children: [
                    {
                        path: '',
                        component: LaboratorioEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'tecnicos/edit/:idTecnico',
                        component: TecnicoLaboratorioEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],

                        data: {
                            breadcrumb: 'Editar Técnico Autorizado',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'tecnicos/create',
                        component: TecnicoLaboratorioEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nuevo Técnico',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },
            {
                path: 'create',
                component: LaboratorioEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Laboratorio',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
    // AGENTES DE CONTROL
    {
        path: 'mantenimiento/registros/agentescontrol',
        data: {
            breadcrumb: 'Agentes de Control',
            menu0: 'MANTENIMIENTO',
            menu1: 'Registros',
        },
        children: [
            {
                path: '',
                component: AgenteControlListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                },
            },
            {
                path: 'edit/:id',

                data: {
                    breadcrumb: 'Editar Agente de Control',
                    actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                },

                children: [
                    {
                        path: '',
                        component: AgenteControlEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                        },
                    },
                    {
                        path: 'agentescontrolca/edit/:idAgenteControlCa',
                        component: AgenteControlCaEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Editar CA Agente Control',
                            actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                        },
                    },
                    {
                        path: 'agentescontrolca/create',
                        component: AgenteControlCaEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Nueva CA Agente Control',
                            actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                        },
                    },
                ],
            },
            {
                path: 'create',
                component: AgenteControlEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Agente de Control',
                    actionCode: EnumCodigosTwTcAcciones.MENU_AGENTES_CONTROL,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(registrosRoutes)],
    exports: [RouterModule],
})
export class RegistrosRoutingModule {}
